import { useLocation } from 'react-router-dom';

/**
 * Hook para extrair o slug da empresa da URL
 * Exemplo: /elo/dashboard -> slug: "elo"
 */
export function useCompanySlug() {
  const location = useLocation();
  
  // Extrair slug do primeiro segmento do path
  const pathParts = location.pathname.split('/').filter(p => p);
  
  // Ignorar rotas públicas
  if (pathParts[0] === 'consulta' || pathParts[0] === 'login') {
    return null;
  }
  
  // Verificar se é uma rota do sistema (sem slug)
  const systemRoutes = ['dashboard', 'super-admin', 'reports', 'companies', 'users', 'customers', 'products', 'categories', 'tickets', 'email-logs', 'email-templates', 'profile'];
  
  if (systemRoutes.includes(pathParts[0])) {
    return null; // Rota sem slug
  }
  
  // Primeiro segmento é o slug da empresa
  return pathParts[0] || null;
}

/**
 * Hook para criar links com slug da empresa
 */
export function useCompanyLink() {
  const slug = useCompanySlug();
  
  return (path) => {
    if (!slug) return path;
    
    // Se o path já começa com o slug, retornar como está
    if (path.startsWith(`/${slug}`)) return path;
    
    // Adicionar slug ao path
    return `/${slug}${path}`;
  };
}
